import { render } from "./WrapperForm.vue?vue&type=template&id=35d4b22c&scoped=true"
import script from "./WrapperForm.vue?vue&type=script&lang=js"
export * from "./WrapperForm.vue?vue&type=script&lang=js"

import "./WrapperForm.vue?vue&type=style&index=0&id=35d4b22c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d4b22c"]])

export default __exports__